import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { Observable, ReplaySubject } from 'rxjs';
import { concatMap, map, take, tap } from 'rxjs/operators';

import { EmployeeProfileService } from './employee-profile.service';
import { ApiCreds, emptyPaystubData, rawPaystubData } from '../models';
import { paystubDetailsUrl, paystubDetailsCleanKeys } from './constants';
import * as utils from './utils/service.utils';
import { PaystubInfo, PaystubData } from '@core/models';

@Injectable({ providedIn: 'root' })
export class PaystubDetailsService {
  paystubDetailsSubject = new ReplaySubject<PaystubData>(1);
  /*** Observable cache of clean PaystubData */
  paystubDetailsData$ = this.paystubDetailsSubject.asObservable();

  constructor(private employeeProfileService: EmployeeProfileService, private http: HttpClient) {}

  //#region //*Helpers

  private fetchData(apiCreds: ApiCreds, paystubInfo: PaystubInfo): Observable<rawPaystubData> {
    const checkId = paystubInfo?.checkId ?? 0;
    const didId = paystubInfo?.didId ?? 0;
    const url = `${paystubDetailsUrl}/${apiCreds.bcl}/${apiCreds.id}/${didId}/${checkId}`;

    return this.http.get<rawPaystubData>(url);
  }

  private formatPaystub(rawPaystub: rawPaystubData): PaystubData {
    const { success, errorMessage, ...filteredData } = rawPaystub;
    const cleanedPaystubDetailsData = utils.cleanApiKeys(paystubDetailsCleanKeys, filteredData);

    return utils.keysToCamelCase(cleanedPaystubDetailsData);
  }
  //#endregion

  private fetchPaystubDetails(paystubInfo: PaystubInfo): Observable<PaystubData> {
    return this.employeeProfileService.apiCreds$.pipe(
      take(1),
      concatMap(apiCreds => this.fetchData(apiCreds, paystubInfo)),
      map(rawPaystub => this.formatPaystub(rawPaystub))
    );
  }

  /** Refreshes Paystub Details from a paystubInfo */
  getPaystubDetail(paystubInfo: PaystubInfo) {
    if (paystubInfo) {
      this.fetchPaystubDetails(paystubInfo).subscribe(paystub => {
        this.paystubDetailsSubject.next(paystub);
      });
    } else {
      this.paystubDetailsSubject.next(null);
    }
  }
}
